<template>
    <div class="row">
        <div class="col-12">
          <div class="card-header-actions">
            <div class="col-12 justify-content-md-end mt-md-0 mt-2 card-header-btns-box">
              <button class="all-btn add-btn m-0" v-if="hasPermission('SETTINGS_BUILDING_RENT_RATE_FOR_LAND_ADD')" @click="showTaxRatePerLandEditModal(null)">{{$t("action.add")}}</button>
            </div>
          </div>
        </div>
        <div class="col-12">
            <div class="table-wrapper">
              <table class="table table-hover">
                  <thead>
                  <tr>
                      <th>#</th>
                      <th>Шахс</th>
                      <th>Вилоят</th>
                      <th>Туман</th>
                      <th>Мулжал (чекка кишлоқ жойлар)</th>
                      <th class="text-center">Зона</th>
                      <th class="text-center">1 кв.м. учун (сўмда)</th>
                      <th>Яратилган сана</th>
                  </tr>
                  </thead>
                  <tbody v-if="!loading && results && results.data">
                  <tr v-for="result in results.data" :key="result.id">
                      <td>{{result.id}}</td>
                      <td>
                          <div class="badge badge-secondary" v-if="result.data.clientType === 'Physical'">{{$t("expert2.field.ownerType.physical")}}</div>
                          <div class="badge badge-secondary" v-if="result.data.clientType === 'Legal'">{{$t("expert2.field.ownerType.legal")}}</div>
                      </td>
                      <td>{{result.data.province.label}}</td>
                      <td><span v-if="result.data.region">{{result.data.region.label}}</span></td>
                      <td><span v-if="result.data.microRegion">{{result.data.microRegion.label}}</span></td>
                      <td class="text-center">
                          <template v-if="result.data.childFields && result.data.childFields.length > 0">
                              <div v-for="(field, index) in result.data.childFields" :key="index">
                                  <span v-if="field.zone > 0">{{field.zone}}</span>
                              </div>
                          </template>
                      </td>
                      <td class="text-center">
                          <template v-if="result.data.childFields && result.data.childFields.length > 0">
                              <div v-for="(field, index) in result.data.childFields" :key="index">
                                  <span> {{field.value}} </span>
                              </div>
                          </template>
                      </td>
                      <td>{{new Date(result.createdDate) | dateFormat('DD/MM/YYYY HH:mm')}}</td>
                  </tr>
                  </tbody>
              </table>
            </div>
            <div class="text-center">
                <div class="loader mt-5 mb-5" v-if="loading"></div>
                <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
            </div>
            <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                <div class="col-12 pt-3 pb-3">
                    <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size" @change="onPageChange">
                    </b-pagination>
                </div>
            </div>
        </div>
        <RentRateForLandModal @change="initList"/>
    </div>
</template>

<script>
    import RentRateForLandModal from './RentRateForLandModal'
    import initFilterModel from '@/shared/filter';
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    export default {
        components: {
            'b-pagination': bPagination,
            RentRateForLandModal
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: null
            }
        },
        methods: {
            initList() {
                this.loading = true;
                const vm = this;
                this.$http.post('dictionary/list/RENT_RATE_FOR_LAND', this.filter)
                    .then(res => {
                        this.results = res.data;
                        vm.loading = false;
                    }, err => {
                        console.log(err);
                        vm.loading = false;
                    });
            },
            showTaxRatePerLandEditModal(data) {
                this.$eventBus.$emit('showRentRateForLandModal',data)
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            }
        },
        created() {
            this.initList();
        }
    }
</script>

<style scoped>

</style>